module.exports = __webpack_public_path__ + "img/WorkSans-Light.da1ced2.svg";